import axios from 'axios';

// Determine API base URL based on environment
const getApiBaseUrl = () => {
  const hostname = window.location.hostname;
  
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    // Local development - point to dev API for testing
    return 'https://5vid5cz96l.execute-api.us-east-2.amazonaws.com/dev';
  } else if (hostname === 'dev.dprtzsmp3o0ut.amplifyapp.com') {
    // Dev environment - NEW DEV API
    return 'https://5vid5cz96l.execute-api.us-east-2.amazonaws.com/dev';
  } else if (hostname === 'dashboard.conceda.com' || hostname === 'www.dashboard.conceda.com') {
    // Production environment - PRODUCTION API
    return 'https://cgupm9q9f9.execute-api.us-east-2.amazonaws.com/prod';
  } else {
    // Fallback to dev for any other domains
    return 'https://5vid5cz96l.execute-api.us-east-2.amazonaws.com/dev';
  }
};

const API_BASE_URL = getApiBaseUrl();

// Helper function to get auth headers with ID token
const getAuthHeaders = () => {
  // Your app uses localStorage.getItem("id_token") with underscore
  const idToken = localStorage.getItem('id_token');
  
  if (!idToken || idToken === 'null' || idToken === 'undefined') {
    console.error('No valid ID token found in localStorage with key "id_token"');
    throw new Error('Authentication required. Please log in again.');
  }
  
  return {
    'Authorization': `Bearer ${idToken}`,
    'Content-Type': 'application/json',
  };
};

// API service for processo updates
export const processoUpdateService = {
  // Get all processos for the dropdown (admin only)
  async getProcessosForUpdate() {
    try {
      const response = await axios.get(`${API_BASE_URL}/processos/update`, {
        headers: getAuthHeaders(),
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching processos for update:', error);
      
      // Enhanced error handling
      if (error.response?.status === 401) {
        throw new Error('Authentication failed. Please log in again.');
      } else if (error.response?.status === 403) {
        throw new Error('Access denied. Admin privileges required.');
      } else {
        throw new Error(`Failed to fetch processos: ${error.response?.data?.error || error.message}`);
      }
    }
  },

  // Get specific processo by referencia (admin only)
  async getProcessoByReferencia(referencia) {
    try {
      const response = await axios.get(`${API_BASE_URL}/processos/update/${referencia}`, {
        headers: getAuthHeaders(),
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching processo by referencia:', error);
      
      if (error.response?.status === 401) {
        throw new Error('Authentication failed. Please log in again.');
      } else if (error.response?.status === 403) {
        throw new Error('Access denied. Admin privileges required.');
      } else if (error.response?.status === 404) {
        throw new Error('Processo not found or inactive.');
      } else {
        throw new Error(`Failed to fetch processo: ${error.response?.data?.error || error.message}`);
      }
    }
  },

  // Update processo (admin only)
  async updateProcesso(referencia, updates) {
    try {
      const response = await axios.put(`${API_BASE_URL}/processos/update/${referencia}`, updates, {
        headers: getAuthHeaders(),
      });
      return response.data;
    } catch (error) {
      console.error('Error updating processo:', error);
      
      if (error.response?.status === 401) {
        throw new Error('Authentication failed. Please log in again.');
      } else if (error.response?.status === 403) {
        throw new Error('Access denied. Admin privileges required.');
      } else if (error.response?.status === 404) {
        throw new Error('Processo not found or inactive.');
      } else if (error.response?.status === 400) {
        throw new Error(`Invalid update data: ${error.response?.data?.error || error.message}`);
      } else {
        throw new Error(`Failed to update processo: ${error.response?.data?.error || error.message}`);
      }
    }
  },
};

export default processoUpdateService;
